import siteSearchPreset from '../item-types/static-page-v2/schema-presets/site_search';
var siteSearchTpaPageId = 'search_results';
export var getSiteSearchSlug = function (installedApps) {
    var _a, _b;
    if (installedApps === void 0) { installedApps = []; }
    return (_b = (_a = installedApps
        .find(function (app) { return app.appDefinitionId === siteSearchPreset.appDefId; })) === null || _a === void 0 ? void 0 : _a.appPages.find(function (page) { return page.tpaPageId === siteSearchTpaPageId; })) === null || _b === void 0 ? void 0 : _b.pageUriSEO;
};
